import { render } from "./PokemonList.vue?vue&type=template&id=25d05208&scoped=true"
import script from "./PokemonList.vue?vue&type=script&lang=js"
export * from "./PokemonList.vue?vue&type=script&lang=js"

import "./PokemonList.vue?vue&type=style&index=0&id=25d05208&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d05208"]])

export default __exports__